import { useBreakpoint } from "@backstage/ui";
import { Paper } from "@internal/backstage-plugin-utility-react";

import { ChatBody } from "./ChatBody";
import styles from "./ChatPanel.module.css";
import { ChatPanelHeader } from "./ChatPanelHeader";

// ── Types ──────────────────────────────────────────────────────────────────────

export interface ChatPanelProps {
    isVisible: boolean;
    isMaximized: boolean;
    onClose: () => void;
    onMaximize: () => void;
}

// ── ChatPanel ──────────────────────────────────────────────────────────────────

export const ChatPanel = ({
    isVisible,
    isMaximized,
    onClose,
    onMaximize,
}: ChatPanelProps) => {
    const { down } = useBreakpoint();
    const isMobile = down("sm");

    const layoutClass = isMobile
        ? styles.mobile
        : isMaximized
        ? styles.desktopMaximized
        : styles.desktop;

    return (
        <Paper
            elevation={2}
            square={isMobile}
            className={`${styles.panel} ${layoutClass} ${
                isVisible ? styles.panelVisible : styles.panelHidden
            }`}
        >
            <ChatPanelHeader
                isMaximized={isMaximized}
                isMobile={isMobile}
                onMaximize={onMaximize}
                onClose={onClose}
            />

            <div className={styles.body}>
                <ChatBody centerEmptyState isVisible={isVisible} />
            </div>
        </Paper>
    );
};
